/* eslint-disable complexity */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/prefer-default-export */
import {
    LiveState,
    IPlayerEvent,
    LiveRoleType,
} from '@tencent/live-components';
import {
    getItem,
    setItem,
} from 'sutils';
import { RoomAction } from './message_const';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import i18n from '@i18next/i18n';
import Snackbar from '@tencent/dui/lib/components/Snackbar';
import FullscreenHandler from '@utils/fullscreen/fullscreen-handler';
import MeetingEventBus from '@src/page/toc/common/meeting-room-manager/components/eventBus';

const LIVE_FLIP_PAGE_TIP_COUNT = 'LIVE_FLIP_PAGE_TIP_COUNT';

// 工具条回调方法
export function onLiveBarCallBack(event, flag, data, extra, liveManager) {
    return MeetingRoomHelper.getInstance().onLiveBarCallBack(event, flag, data, extra, liveManager);
}

export class MeetingRoomHelper {
    private static instance;
    public static getInstance() {
        if (!MeetingRoomHelper.instance) {
            MeetingRoomHelper.instance = new MeetingRoomHelper();
        }
        return MeetingRoomHelper.instance;
    }
    public playerState: any = {};
    public disableAutoEndPlay: boolean;
    public constructor() {
        this.disableAutoEndPlay = false;
    }

    // Player中无法操作的，放在这里操作、上报。
    public onLiveBarCallBack(event, flag, data, extra, liveManager) {
        console.log('LiveBarEvent -> ', event);
        switch (event) {
            case IPlayerEvent.Prev:
                MeetingEventBus.sendRoomEvent2Player(RoomAction.PrevPage);
                break;
            case IPlayerEvent.Next:
                MeetingEventBus.sendRoomEvent2Player(RoomAction.NextPage);
                break;
            case IPlayerEvent.SyncWithMaster:
                MeetingEventBus.sendRoomEvent2Player(RoomAction.SyncWithMaster);
                break;
            case IPlayerEvent.ShowPopWindow:
                // 弹窗起来后，不再响应键盘快捷键
                if (flag) {
                    MeetingEventBus.sendRoomEvent2Player(RoomAction.PopWindowShow);
                } else {
                    MeetingEventBus.sendRoomEvent2Player(RoomAction.PopWindowHide);
                }
                break;
            case IPlayerEvent.Exit:
                {
                    const liveState = liveManager.liveInfo.state;
                    if (liveState === LiveState.OnAir) {
                        tdw({
                            opername: 'doc_ppt',
                            module: 'remote_initiate',
                            action: 'end_clk',
                        });
                    } else {
                        tdw({
                            opername: 'doc_ppt',
                            module: 'local_play',
                            action: 'drop',
                        });
                    }
                    MeetingEventBus.sendRoomEvent2Player(RoomAction.ExitShow);
                }
                break;
            case IPlayerEvent.Laser:
                {
                    // Player中响应操作
                    const param = {
                        opername: 'doc_ppt',
                        module: '',
                        action: '',
                    };
                    if (this.playerState.laserTurnOn) {
                        if (liveManager.liveState === LiveState.OnAir) {
                            // 远程演示激光笔上报
                            param.module = 'remote_initiate';
                            param.action = 'r_shut';
                        } else {
                            // 本地演示激光笔上报
                            param.module = 'local_play';
                            param.action = 'shut';
                        }
                    } else {
                        if (liveManager.liveState === LiveState.OnAir) {
                            // 远程演示激光笔上报
                            param.module = 'remote_initiate';
                            param.action = 'r_open';
                        } else {
                            // 本地演示激光笔上报
                            param.module = 'local_play';
                            param.action = 'open';
                        }
                    }
                    tdw(param);
                    MeetingEventBus.sendRoomEvent2Player(RoomAction.TurnLaser);
                }
                break;
            case IPlayerEvent.FullScreen:
                {
                    const { isFullscreen, exitFullscreen, requestFullscreen } = FullscreenHandler.getInstance();
                    tdw({
                        opername: 'doc_ppt',
                        module: 'remote_watch',
                        action: isFullscreen ? 'out_screen' : 'en_screen',
                    });
                    this.disableAutoEndPlay = true;
                    if (isFullscreen) {
                        exitFullscreen();
                    } else {
                        requestFullscreen(document.body);
                    }
                }
                break;
            case IPlayerEvent.ShowMemberList:
                {
                    // todo
                }
                break;
            case IPlayerEvent.CreateMeeting:
                {
                    tdw({
                        opername: 'doc_ppt',
                        module: 're_show',
                        action: 'open_meeting',
                        ver5: flag,
                        ver6: JSON.stringify({
                            cost: extra,
                            errorMsg: flag ? '' : data,
                        }),
                    });
                }
                break;
            case IPlayerEvent.DissloveMeeting:
                {
                    if (flag) {
                        tdw({
                            opername: 'doc_ppt',
                            module: 're_show',
                            action: 'stop_meeting',
                        });
                    }
                }
                break;
            case IPlayerEvent.JoinMeeting:
                {
                    if (liveManager.role === LiveRoleType.Audience) {
                        tdw({
                            opername: 'doc_ppt',
                            module: 're_show',
                            action: 'join_meeting',
                            ver5: flag,
                            ver6: JSON.stringify({
                                cost: extra,
                                errorMsg: flag ? '' : data,
                            }),
                        });
                    }
                }
                break;
            case IPlayerEvent.QuitMeeting:
                {
                    if (liveManager.role === LiveRoleType.Audience) {
                        tdw({
                            opername: 'doc_ppt',
                            module: 're_show',
                            action: 'quit_meeting',
                        });
                    }
                }
                break;
            case IPlayerEvent.StartLiving:
                {
                    // ToolBar 中发起了liveBegin,这里只上报
                    tdw({
                        opername: 'doc_ppt',
                        module: 'remote_initiate',
                        action: 'enter_panel',
                    });
                    // 本地演示成功发起远程演示 上报，两个上报含义一样ㄟ( ▔, ▔ )ㄏ
                    tdw({
                        opername: 'doc_ppt',
                        module: 'remote_initiate',
                        action: 'lo_edit',
                    });
                }
                break;
            case IPlayerEvent.ShowInvite:
                {
                    // ToolBar 中已经操作过了，这里只上报
                    tdw({
                        opername: 'doc_ppt',
                        module: 'remote_initiate',
                        action: 'clk',
                    });
                }
                break;
            case IPlayerEvent.CopyLink:
                {
                    this.onCopyLink(data);
                }
                break;
            case IPlayerEvent.AudienceFlip:
                {
                    // ToolBar 中已经操作过了，这里只上报
                    if (liveManager) {
                        const act = flag ? 'open' : 'shut';
                        // 上报
                        if (liveManager.liveInfo.state === LiveState.OnAir) {
                            // 演示中设置
                            tdw({
                                opername: 'doc_ppt',
                                module: 'remote_initiate',
                                action: `mid_${act}`,
                            });
                        } else if (liveManager.liveInfo.state === LiveState.Pause) {
                            // 演示前设置
                            tdw({
                                opername: 'doc_ppt',
                                module: 'remote_initiate',
                                action: act,
                            });
                        }
                    }
                }
                break;
            case IPlayerEvent.Mute:
                {
                    if (flag) {
                        tdw({
                            opername: 'doc_ppt',
                            module: 're_show',
                            action: 'ban_someone',
                        });
                    }
                }
                break;
            case IPlayerEvent.AllMute:
                {
                    if (flag) {
                        tdw({
                            opername: 'doc_ppt',
                            module: 're_show',
                            action: 'mute_all',
                        });
                    }
                }
                break;
            case IPlayerEvent.NeedNewUserTip:
            {
                // 开关允许翻页按钮时，对新用户进行提示，这里判断是否新用户
                const isAudience = liveManager.role === LiveRoleType.Audience;
                if (isAudience) {
                    const countStr = getItem(LIVE_FLIP_PAGE_TIP_COUNT) || '0';
                    let count = parseInt(countStr, 10) || 0;
                    if (count < 3) {
                        count += 1;
                        setItem(LIVE_FLIP_PAGE_TIP_COUNT, `${count}`);
                        return true;
                    }
                }
                return false;
            }
            case IPlayerEvent.ToggleNote:
                break;
            case IPlayerEvent.ZoomIn:
                MeetingEventBus.sendRoomEvent2Player(RoomAction.ZoomIn);
                break;
            case IPlayerEvent.ZoomOut:
                MeetingEventBus.sendRoomEvent2Player(RoomAction.ZoomOut);
                break;
            case IPlayerEvent.ToggleView:
                MeetingEventBus.sendRoomEvent2Player(RoomAction.ToggleView);
                break;
            case 'Annotation':
                MeetingEventBus.sendRoomEvent2Player(RoomAction.TurnAnnotation, { enable: flag });
                break;
            default:
                break;
        }
    }

    private onCopyLink(url) {
        const title = window.pray?.().pptTitle;
        const link = i18n.t('【远程演示】{0}\n{1}', { 0: title, 1: url });
        const textarea = document.createElement('textarea');
        textarea.readOnly = true;
        textarea.style.zIndex = '0';
        textarea.style.opacity = '0';
        textarea.style.top = '-9999px';
        textarea.style.left = '-9999px';
        textarea.style.position = 'fixed';
        document.body.appendChild(textarea);
        textarea.value = link;
        textarea.select();
        const isCopySuccess = document.execCommand('copy');
        document.body.removeChild(textarea);
        if (isCopySuccess) {
            Snackbar.show({
                message: i18n.t('复制链接成功'),
                type: 'success',
                duration: 3000,
                autoClose: true,
            });
        } else {
            Snackbar.show({
                message: i18n.t('由于浏览器版本过低，请使用cmd+C复制链接。'),
                type: 'info',
                duration: 3000,
                autoClose: true,
            });
        }
    }
}
